/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 11.1.0
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * A routing profile that determines which roads you can access, and how desirable they are based on the type of travel and other parameters.
 * Profiles with a `_traffic` suffix use heuristically-selected traffic data sources to improve ETA and time-dependent route quality while balancing the credit cost. The `_traffic_premium` profiles leverage multiple types of data for maximum accuracy. Traffic-influenced profiles use the same costing options as their base profile (e.g., use the `auto` key in `costing_options` for `auto_traffic`).
 * @export
 */
export const CostingModel = {
  Auto: "auto",
  AutoTraffic: "auto_traffic",
  AutoTrafficPremium: "auto_traffic_premium",
  Bus: "bus",
  BusTraffic: "bus_traffic",
  BusTrafficPremium: "bus_traffic_premium",
  Taxi: "taxi",
  TaxiTraffic: "taxi_traffic",
  TaxiTrafficPremium: "taxi_traffic_premium",
  Truck: "truck",
  TruckTraffic: "truck_traffic",
  TruckTrafficPremium: "truck_traffic_premium",
  Bicycle: "bicycle",
  Bikeshare: "bikeshare",
  MotorScooter: "motor_scooter",
  Motorcycle: "motorcycle",
  Pedestrian: "pedestrian",
  LowSpeedVehicle: "low_speed_vehicle",
} as const;
export type CostingModel = (typeof CostingModel)[keyof typeof CostingModel];

export function instanceOfCostingModel(value: any): boolean {
  for (const key in CostingModel) {
    if (Object.prototype.hasOwnProperty.call(CostingModel, key)) {
      if (CostingModel[key as keyof typeof CostingModel] === value) {
        return true;
      }
    }
  }
  return false;
}

export function CostingModelFromJSON(json: any): CostingModel {
  return CostingModelFromJSONTyped(json, false);
}

export function CostingModelFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CostingModel {
  return json as CostingModel;
}

export function CostingModelToJSON(value?: CostingModel | null): any {
  return value as any;
}

export function CostingModelToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CostingModel {
  return value as CostingModel;
}
